import { KnownQuotasRefs, QuotaRef, useQuotas } from '@app/api';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Recruitment } from '@app/api';
import { CriterionQuotaBoxLine } from './CriterionQuotaBoxLine';
import { useRecruitmentExtendedCriterion } from './../hooks/useRecruitmentExtendedCriterion';
import { QuotaBoxLine } from './QuotaBoxLine';
import { useMemo } from 'react';
import { exists, t } from 'i18next';
import { getColorForElement } from 'pages/Dashboard/EditSession/components/Quota/useQuotasHooks';
import { CenteredLoader } from '@app/core';

interface Props {
  recruitment?: Recruitment;
  taggedCriteria?: string[];
  onAddQuotaItemTag?: (criterion: QuotaRef) => any;
  onRemoveQuotaItemTag?: (criterion: QuotaRef) => any;
}

const useStyles = createUseStyles<string, {}, Theme>((theme: Theme) => ({
  container: { ...theme.fonts.body },
}));

export const getQuotaItemLabel = (
  item: string,
  ref?: string | undefined,
): string => {
  const key = `sessions.details.boxes.quota.ref.${ref}.${item}`;
  if (!!ref && exists(key)) {
    return t(key);
  }

  return item;
};

export const QuotaBox = ({
  recruitment,
  taggedCriteria,
  onAddQuotaItemTag,
  onRemoveQuotaItemTag,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const {
    audienceCriteria: audienceCriteriaWithQuotaLabel,
    screeningCriteria: screeningCriteriaWithForm,
    isLoading,
  } = useRecruitmentExtendedCriterion(recruitment);

  const { data: quotas } = useQuotas(
    recruitment?.sessionId,
    KnownQuotasRefs,
    true,
  );

  const formatedQuotas = useMemo(
    () =>
      quotas?.map((quota) => {
        return {
          ...quota,
          label: getQuotaItemLabel(quota.item as string, quota?.ref),
        };
      }),
    [quotas],
  );

  const knownQuotasRefs = KnownQuotasRefs.filter(
    (a) => !!formatedQuotas?.find((q) => q.ref === a),
  );

  if (isLoading) {
    return <CenteredLoader />;
  }

  return (
    <div>
      <div className={classes.container}>
        {[...audienceCriteriaWithQuotaLabel, ...screeningCriteriaWithForm].map(
          (criterion) => (
            <CriterionQuotaBoxLine
              criterion={criterion}
              isTagged={taggedCriteria?.includes(criterion.fieldRef)}
              onAddQuotaItemTag={onAddQuotaItemTag}
              onRemoveQuotaItemTag={onRemoveQuotaItemTag}
            />
          ),
        )}
        {knownQuotasRefs.map((quotaRef: string) => (
          <QuotaBoxLine
            reference={{
              ref: quotaRef,
              label: t(`sessions.details.boxes.quota.ref.${quotaRef}.label`),
              color: getColorForElement(quotaRef),
            }}
            quotas={formatedQuotas?.filter((quotas) => quotas.ref === quotaRef)}
            isTagged={taggedCriteria?.includes(quotaRef)}
            onAddQuotaItemTag={onAddQuotaItemTag}
            onRemoveQuotaItemTag={onRemoveQuotaItemTag}
          />
        ))}
      </div>
    </div>
  );
};
